import { ActionTypes } from "../constantes/ActionTypes";
import _ from "lodash";

const initialState = {
  data: [],
  isLoading: false,
  error: "",
  info: "",
};
export const ShipmentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.ACTION_SHIPMENT_INIT:
      return initialState;
    case ActionTypes.ACTION_SHIPMENT_START:
      return {
        ...state,
        isLoading: true,
        info: undefined,
        error: undefined,
      };
    case ActionTypes.ACTION_SHIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
        error: "",
        info: _.isEmpty(payload?.list) ? "Aucun résultat trouvé" : undefined,
      };
    case ActionTypes.ACTION_SHIPMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
